import clsx from "clsx"
import "./MultiStyleText.css"

interface MultiStyleTextProps extends React.HTMLAttributes<HTMLSpanElement> {
    flex?: boolean | undefined
    children?: string | undefined | null
    className1?: string
    className2?: string
    style1?: React.CSSProperties | undefined
    style2?: React.CSSProperties | undefined
    splitTheWord?: boolean
}

const MultiStyleText = (props: MultiStyleTextProps) => {
    const {className, className1, className2, flex = false, style1, style2, splitTheWord, children: _children} = props
    const children = _children?.trim()

    let part1 = ""
    let part2 = ""

    if (!children) return null
    const numberOfChars = children.length
    const mid = Math.floor(numberOfChars / 2)
    const words = children.split(" ")
    const numberOfWords = words.length

    let initialPositionMidWord = 0
    let endingPositionMidWord = 0
    let phraseSplitPoint = 0

    const splitRightInHalf = numberOfWords === 1 || splitTheWord

    if (splitRightInHalf) {
        part1 = children.substring(0, mid)
        part2 = children.substring(mid, children.length)
    } else {
        for (let index = mid; index > 0; index--) {
            if (children[index] === " ") {
                initialPositionMidWord = index + 1
                break
            }
        }

        for (let index = mid; index <= children.length; index++) {
            if (children[index] === " ") {
                endingPositionMidWord = index
                break
            }
        }

        if (initialPositionMidWord === 0) {
            phraseSplitPoint = endingPositionMidWord
        } else if (mid - initialPositionMidWord > endingPositionMidWord - mid) {
            phraseSplitPoint = initialPositionMidWord
        } else {
            phraseSplitPoint = endingPositionMidWord
        }
        part1 = children.substring(0, phraseSplitPoint)
        part2 = children.substring(phraseSplitPoint, children.length)
    }

    return (
        <span className={clsx("multi-style-vu88", flex ? "flex-vu88" : "grid-vu88", className)}>
            <span className={clsx("part-1-vu88", !splitRightInHalf ? "space-vu88" : "", className1)} style={style1}>
                {part1}
            </span>
            <span className={clsx("part-2-vu88", !splitRightInHalf ? "space-vu88" : "", className2)} style={style2}>
                {part2.trimEnd()}
            </span>
        </span>
    )
}

export default MultiStyleText
